module.exports = __webpack_public_path__ + "img/blad.8a761e0c.svg";